import { render } from "./ProjectDetail.vue?vue&type=template&id=d9d078da"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/casey/Documents/Development/visualspace_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__